export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: 'Instant AI Implementation',
      description: 'Deploy AI business solutions and machine learning models in minutes, not months. Our Charlotte NC platform integrates seamlessly with your existing systems for immediate business transformation and digital innovation.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Enterprise Security & Compliance',
      description: 'Bank-level security with end-to-end encryption ensures your business intelligence data, predictive analytics, and sensitive information remain protected and compliant with industry standards.'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Real-Time Business Intelligence',
      description: 'Access live business intelligence dashboards with actionable insights, data analytics, and predictive models that update automatically as your Charlotte NC business operates.'
    },
    {
      icon: 'ri-robot-line',
      title: 'Business Automation AI',
      description: 'AI-powered business automation and machine learning handles repetitive tasks, workflow optimization, and process automation, freeing your team to focus on strategic initiatives and business transformation.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Deal Evaluator & ROI Analysis',
      description: 'Expert deal evaluator capabilities with predictive analytics reduce operational overhead by up to 40% while increasing productivity, profitability, and business efficiency through data-driven insights.'
    },
    {
      icon: 'ri-team-line',
      title: '24/7 AI Expert Support',
      description: 'Charlotte NC AI expert support team and AI consultants available around the clock to ensure your AI solutions, machine learning models, and business automation run smoothly and deliver results.'
    }
  ];

  return (
    <section id="features" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-4">
            Why Choose Curtis Waters AI Solutions for Business Intelligence?
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Our <strong>Charlotte NC AI platform</strong> delivers <strong>business intelligence</strong>, <strong>predictive analytics</strong>, <strong>machine learning</strong>, and <strong>business transformation</strong> for companies that want to scale efficiently with <strong>AI solutions</strong> and <strong>data-driven decision making</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-4 sm:p-6 rounded-lg hover:bg-gray-50 transition-colors">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className={`${feature.icon} text-2xl sm:text-3xl text-red-600`} aria-hidden="true"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 px-2">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed px-2">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}